import { UpdateExternalEventVariantDocument } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';

export function useExternalEventVariantUpdate() {
    const updateVariantMutation = useMutation(UpdateExternalEventVariantDocument, {
        fetchPolicy: 'no-cache',
    });

    async function updateExternalEventVariantName(id: string, name: string, feedId: string) {
        const result = await updateVariantMutation.mutate({ id, name, feedId });
        return result;
    }

    return {
        updateExternalEventVariantName,
    };
}
